const Banner = () => {
  return (
    <div className="contact-banner">
      <p>COPYRIGHT © 2024 IZRADA SAJTA VORTEX-MK | SVA PRAVA ZADRŽANA</p>
    </div>
  );
};

export default Banner;
